import {post,get, nGet,nPost} from '../../libs/ajax.js';

export default {
    /* 创建工单 */

    // 项目搜索
    getProjectOptions:(data,options) => {
        return nPost('/work_order/get_project_list', data, options);
    },
    // 项目详情
    getProjectDetail:(data,options) => {
        return post('/work_order/get_project_detail', data, options);
    },
    getProductList:(data,options) => {
        return post('/work_order/get_product_list', data, options);
    },
    // 项目详情-近30天内日均消耗
    getProjectDetailCost:(data,options) => {
        return get('/work_order/get_project_detail_cost', data, options);
    },
    // 获取制作部门
    getMaterialGroup:(data,options) => {
        return get('/work_order/get_material_group', data, options);
    },
    // 获取素材配置
    getMaterialDetail:(data,options) => {
        return get('/work_order/get_material_detail', data, options);
    },
    // 获取素材的格式
    getMaterialFormat:(data,options) => {
        return get('/work_order/tag_config/get_material_format', data, options);
    },
    // 创建工单
    saveOrder:(data,options) => {
        return post('/work_order/save', data, options);
    },
    // 编辑工单
    updateOrder:(data,options) => {
        return post('/work_order/update', data, options);
    },
    // 获取工单信息
    getOrderInfo:(data,options) => {
        return get('/work_order/get_order_info', data, options);
    },

    // 获取投放场景/投放版位
    getDeliveryList:(data,options) => {
        return get('/work_order/get_delivery_list', data, options);
    },
    // 获取媒体
    getPlatList:(data,options) => {
        return get('/work_order/get_plat_list', data, options);
    },
    // 视频标签列表
    getVideoLabelConfigList:(data,options) => {
        return get('/work_order/label_video_config/get_list', data, options);
    },
    // 图片标签列表
    getImageLabelConfigList:(data,options) => {
        return get('/work_order/label_config/get_list', data, options);
    },

    // 上传附件 - 获取腾讯云上传配置参数
    getUploadConf:(data,options) => {
        return post('/get_upload_conf', data, options);
    },
    // 校验项目有待验收/待使用的素材
    checkProjectMaterial:(data,options) => {
        return post('/work_order/check_material', data, options);
    },
    // 保存弹窗埋点
    saveBuriedPoint:(data,options) => {
        return post('/work_order/save_buried_point', data, options);
    },
    // 获取项目标签
    getProjectTag:(data,options) => {
        return get('/work_order/get_project_tag', data, options);
    }
}
